module.exports = __webpack_public_path__ + "static/img/fabioBisi.347eb20.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/fabioBisi.png
// module id = vwzg
// module chunks = 1